<template>
  <tr :class="active ? 'active-row' : ''">
    <td name="position">
      <b>{{ item.position }}</b>
      <a
        v-if="hasError"
        class="refresh"
        @click="refetch(item.uuid, item.url, item.id)"
      >
        <img
          alt="refresh"
          class="refresh-img"
          src="@/assets/refresh.svg"
        >
      </a>
    </td>
    <td name="domain">
      <div v-if="active">
        <span class="your-site-label">Your Site</span><br>
      </div>
      <a
        :href="item.url"
        target="_blank"
      ><u>{{ item.clean_domain }}</u></a>
    </td>
    <td name="content">
      <span v-if="isBusy">
        <preloader :color="active ? preloader.active : preloader.default" />
      </span>
      <span v-else-if="!additionalData || hasError">--</span>
      <span v-else-if="additionalData.domain.content_count === 0">No data</span>
      <span v-else>{{ additionalData.domain.content_count }} words</span>
    </td>
    <td name="links">
      <span v-if="isBusy">
        <preloader :color="active ? preloader.active : preloader.default" />
      </span>
      <span v-else-if="!additionalData || hasError">--</span>
      <span v-else>{{ additionalData.domain.backlinks }}</span>
    </td>
    <td name="domain-age">
      <span v-if="isBusy">
        <preloader :color="active ? preloader.active : preloader.default" />
      </span>
      <span v-else-if="!additionalData || hasError">--</span>
      <span v-else-if="additionalData.domain.age === 0">No data</span>
      <span v-else>{{ humanise(additionalData.domain.age) }}</span>
    </td>
    <!-- <td name="page-count">
      <span v-if="isBusy">
        <preloader :color="active ? preloader.active : preloader.default" />
      </span>
      <span v-else-if="!additionalData || hasError">--</span>
      <span v-else>{{ additionalData.domain.page_count }}</span>
    </td> -->
    <td name="load-time">
      <span v-if="isBusy">
        <preloader :color="active ? preloader.active : preloader.default" />
      </span>
      <span v-else-if="!additionalData || hasError">--</span>
      <span v-else-if="additionalData.domain.time_to_load === 0">No data</span>
      <span v-else>{{ formatTimeToLoad(additionalData.domain.time_to_load) }}</span>
    </td>
  </tr>
</template>
<script>
import { mapState } from 'vuex'
import Preloader from "../../Preloader";

export default {

  components: {
    Preloader
  },

  props: {
    item: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    isBusy: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      preloader: {
        active: '#fff',
        default: '#333'
      }
    }
  },

  computed:{
    ...mapState('app', ['url','competitorErrors']),
    ...mapState('keyword', ['additionalResults']),
    
    additionalData() {
      if(!this.additionalResults.hasOwnProperty(this.item.uuid))
        return null;

      return this.additionalResults[this.item.uuid];
    }

  },

  methods: {

    refetch(uuid, url, keyword) {
      this.$emit('on-refetch', { data: { uuid, url, keyword } })
    },

    formatTimeToLoad(seconds) {
      return `${(seconds*10).toFixed(2)}s`
    }

  },
}
</script>
<style lang="scss" scoped>
  .table thead th,
  .table tbody td {
    border: none;
  }
  .table tbody td {
    padding: 1.2rem;
  }
  .table tbody tr {
    transform: scale(1);
    border-left: 2rem solid white;
    border-right: 2rem solid white;
    a {
      color: #212529;
    }
  }
  .table tbody tr.active-row {
    box-shadow: 0 4px 7px rgba(182, 182, 182, 0.9);
    background-image: linear-gradient(270deg, #3caef3 0%, #266ce7 100%);
    border-left: 0 solid white;
    border-right: 0 solid white;
    td,
    a {
      color: #fff;
    }
    td:first-child {
      padding-left: 21px;
    }
  }
  .your-site-label {
    color: #ffffff;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    box-shadow: 0 2px 14px rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(270deg, #fe5c07 0%, #ff943a 100%);
    padding: 3px;
  }
  .active-row {
    box-shadow: 0 4px 7px rgba(182, 182, 182, 0.9);
    background-image: linear-gradient(270deg, #3caef3 0%, #266ce7 100%);
    border-left: 0 solid white;
    border-right: 0 solid white;
    td {
      vertical-align: middle;
    }
    a, p {
      color: #fff;
    }
  }

  .refresh {
    position: absolute;
    right: -10px;
    display: flex;
    top: 0px;
    bottom: 0;
    background: #f96e6e;
    padding: 5px 10px;
    cursor: pointer;
    &:hover{
      background: #406a96;
    }
  }

  .refresh-img {
    width: 22px;
  }

</style>